export default __webpack_public_path__ + "static/media/image-john.5253a557.jpg";